import { Autocomplete, Box, TextField } from "@mui/material";
import { useContext } from "react";
import { GlobalContext } from "../../../../common/Context";
import BarChartIcon from "@mui/icons-material/BarChart";
import { black } from "../../../../../theme/colours";

const SponsorDDL = ({ data, selected, handleChange, placeholder }) => {
  const { mobileView, tabletView } = useContext(GlobalContext);

  const ddlStyle = {
    position: !mobileView && "absolute",
    top: tabletView ? "0.75rem" : 0,
    right: 0,
    width: mobileView ? "auto" : tabletView ? "15rem" : "20rem",
    mb: (mobileView || tabletView) && "1.5rem",
    borderRadius: "6px",
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "& label, & svg, & label.Mui-focused": {
      color: "#C31CF3",
    },
  };
  const inputStyle = {
    height: "1rem",
    color: "#C31CF3",
    fontSize: "1rem",
    fontWeight: 600,
    paddingLeft: "1rem",
  };
  const optionStyle = (option) => {
    if (option.id === 0) {
      return {
        color: black,
        fontWeight: 700,
      };
    }
    return {};
  };

  const handleSelect = (event, value) => {
    let selected = { ...value };
    if (selected.id === 0) {
      selected.title = "";
    }
    handleChange(selected);
  };

  return (
    <Autocomplete
      sx={ddlStyle}
      disableClearable={true}
      options={data}
      value={selected}
      disablePortal
      onChange={handleSelect}
      autoHighlight
      getOptionLabel={(option) => option.title}
      renderOption={(props, option) => (
        <Box sx={optionStyle(option)} component="li" {...props} key={option.id}>
          {option.title}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={placeholder}
          inputProps={{
            ...params.inputProps,
            autoComplete: "new-password",
            style: inputStyle,
          }}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <>
                <BarChartIcon />
                {params.InputProps.startAdornment}
              </>
            ),
          }}
        />
      )}
      ListboxProps={{
        style: {
          maxHeight: "11rem",
        },
      }}
    />
  );
};

export default SponsorDDL;
